import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, merge, Subscription } from 'rxjs';
import { AuthService } from './auth.service';

const TIMEOUT_MS = 3 * 60 * 1000;
const EVENTS = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'] as const;

@Injectable({ providedIn: 'root' })
export class InactivityService {

    private timer: ReturnType<typeof setTimeout> | null = null;
    private eventSub: Subscription | null = null;

    constructor(
        private authService: AuthService,
        private router: Router,
        private ngZone: NgZone,
    ) {}

    start(): void {
        this.stop();
        this.ngZone.runOutsideAngular(() => {
            this.eventSub = merge(
                ...EVENTS.map(e => fromEvent(document, e))
            ).subscribe(() => this.reset());
            this.scheduleLogout();
        });
    }

    stop(): void {
        if (this.timer) { clearTimeout(this.timer); this.timer = null; }
        this.eventSub?.unsubscribe();
        this.eventSub = null;
    }

    private reset(): void {
        if (this.timer) clearTimeout(this.timer);
        this.scheduleLogout();
    }

    private scheduleLogout(): void {
        this.timer = setTimeout(() => {
            this.ngZone.run(() => {
                this.stop();
                this.authService.logout();
                this.router.navigateByUrl('/signin', { replaceUrl: true });
            });
        }, TIMEOUT_MS);
    }
}
